module.exports = __webpack_public_path__ + "img/jk3.532b3ef0.png";